
import { BaseButton } from "./button.styles";
const Button = ({children})=>{
	return(
		<BaseButton>{children}</BaseButton>
	)
}

export default Button;